(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  function run(){
    var root=document.querySelector('.nhome'); if(!root) return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('nh-in'); io.unobserve(e.target);
        e.target.querySelectorAll('[data-count]').forEach(function(el){
          var end=parseFloat(el.getAttribute('data-count')), dec=(end%1!==0)?1:0, t0=null, dur=1100;
          function step(ts){ if(!t0)t0=ts; var p=Math.min((ts-t0)/dur,1); var v=(end*(1-Math.pow(1-p,3)));
            el.textContent=v.toFixed(dec); if(p<1) requestAnimationFrame(step); else el.textContent=end.toFixed(dec); }
          requestAnimationFrame(step);
        });
      }});
    },{threshold:.18});
    root.querySelectorAll('.nh-rise').forEach(function(el){ io.observe(el); });
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-promobar"] && !Shopify.designMode) return;
  try {
    
(function(){
  // SHARED DAILY DEADLINE: the sale clock counts down to MIDNIGHT (America/New_York)
  // and shows the SAME remaining time to every visitor. It is NOT a per-visitor 24h
  // window and does NOT reset to the same value each time someone enters the site —
  // it resets at one specific time every day (00:00 ET) for everyone.
  var TZ="America/New_York";
  function secsLeft(){
    var now=new Date(), s;
    try{
      var f=new Intl.DateTimeFormat("en-US",{timeZone:TZ,hour12:false,hour:"2-digit",minute:"2-digit",second:"2-digit"});
      var o={}; f.formatToParts(now).forEach(function(p){ if(p.type!=="literal") o[p.type]=p.value; });
      var h=parseInt(o.hour,10)%24, m=parseInt(o.minute,10), sec=parseInt(o.second,10);
      s=86400-(h*3600+m*60+sec);
    }catch(e){
      var e2=new Date(now); e2.setHours(24,0,0,0); s=Math.floor((e2-now)/1000); // local-midnight fallback
    }
    if(s<=0) s+=86400;
    return s;
  }
  function pad(n){ return n<10 ? "0"+n : ""+n; }
  var bars=document.querySelectorAll("[data-nura-count]");
  if(!bars.length) return;
  function tick(){
    var diff=secsLeft();
    var hh=pad(Math.floor(diff/3600)), mm=pad(Math.floor((diff%3600)/60)), ss=pad(diff%60);
    bars.forEach(function(b){
      var H=b.querySelector("[data-h]"), M=b.querySelector("[data-m]"), S=b.querySelector("[data-s]");
      if(H)H.textContent=hh; if(M)M.textContent=mm; if(S)S.textContent=ss;
    });
  }
  tick(); setInterval(tick,1000);
})();

/* === RubyBeam PDP enhancement === */
/* RubyBeam PDP enhancements — per-area 30-day transformation (cut-out image + live graph),
   scroll clamp, compare-at price. Loaded site-wide via the promobar script block; guards to band PDPs. */
(function(){
  if (window.__rbfx) return; window.__rbfx = 1;

  var AREAS = {
    waist: { name:"Waist", metric:"Waist circumference",     start:34.0, end:30.8, unit:"in" },
    thigh: { name:"Thigh", metric:"Thigh circumference",     start:22.4, end:20.6, unit:"in" },
    arm:   { name:"Arm",   metric:"Upper-arm circumference", start:12.6, end:11.5, unit:"in" },
    neck:  { name:"Neck",  metric:"Under-chin & neckline",   start:14.6, end:13.8, unit:"in" },
    portable: { name:"Every area", metric:"Inches off per area", start:34.0, end:30.8, unit:"in" },
    lymph: { name:"Waist", metric:"Waist circumference", start:33.5, end:30.1, unit:"in" }
  };
  function areaKey(){
    var p = (location.pathname||"").toLowerCase();
    if (/\/lymphaflow|\/lymph\b/.test(p)) return "lymph";
    if (/\/sculptor/.test(p)) return "portable";
    if (/nb-neck|nurasculptt|\/neck/.test(p)) return "neck";
    if (/nb-thigh|thighs-wrap|nurasculpt-thigh|\/thigh/.test(p)) return "thigh";
    if (/nb-arm|nurabeam|\/arm/.test(p)) return "arm";
    return "waist"; /* nb-waist, waist-wrap, default */
  }
  var easeOut = function(t){ return 1 - Math.pow(1-t, 3); };

  /* ---------- per-product 30-day line graph (animated reveal on scroll, no image) ---------- */
  function buildGraph(){
    var wrap = document.querySelector(".nura__graphwrap");
    if (!wrap || wrap.querySelector(".rbfx")) return;
    var A = AREAS[areaKey()], delta = Math.abs(A.start - A.end);

    var VW=680, VH=330, L=56, R=34, T=26, B=48;
    var x0=L, x1=VW-R, y0=T, y1=VH-B, pad=delta*0.42+0.3;
    var vmax=Math.max(A.start,A.end)+pad, vmin=Math.min(A.start,A.end)-pad;
    function px(d){ return x0+(d/30)*(x1-x0); }
    function valAt(d){ return A.start+(A.end-A.start)*easeOut(d/30); }
    function py(v){ return y0+(vmax-v)/(vmax-vmin)*(y1-y0); }
    var pts=[]; for (var d=0; d<=30; d++) pts.push([px(d),py(valAt(d))]);
    var dFull = pts.map(function(p,i){ return (i?"L":"M")+p[0].toFixed(1)+" "+p[1].toFixed(1); }).join(" ");
    var dArea = "M"+x0+" "+y1+" L"+pts.map(function(p){ return p[0].toFixed(1)+" "+p[1].toFixed(1); }).join(" L")+" L"+x1.toFixed(1)+" "+y1+" Z";
    var endX=px(30), endY=py(A.end);
    var yl=""; for (var g=0; g<=2; g++){ var yy=y0+(y1-y0)*g/2, vv=vmax-(vmax-vmin)*g/2;
      yl+='<line class="rbfx-grid" x1="'+x0+'" y1="'+yy.toFixed(1)+'" x2="'+x1+'" y2="'+yy.toFixed(1)+'"></line>'
       +  '<text class="rbfx-ytxt" x="'+(x0-10)+'" y="'+(yy+3.5).toFixed(1)+'">'+vv.toFixed(1)+'</text>'; }
    var xl=""; [0,10,20,30].forEach(function(dd){ xl+='<text class="rbfx-xtxt" x="'+px(dd).toFixed(1)+'" y="'+(y1+24)+'">Day '+dd+'</text>'; });

    var html =
      '<div class="rbfx" data-rbfx>'
      + '<div class="rbfx-head">'
      +   '<span class="rbfx-eyebrow">'+A.metric+'<i> · 30-day study</i></span>'
      +   '<span class="rbfx-readout"><b class="rbfx-delta" data-rb-delta>-0.0 '+A.unit+'</b><i>in 30 days</i></span>'
      + '</div>'
      + '<div class="rbfx-chartwrap">'
      +   '<svg class="rbfx-svg" viewBox="0 0 '+VW+' '+VH+'" preserveAspectRatio="xMidYMid meet" aria-label="'+A.metric+' reduced from '+A.start.toFixed(1)+' to '+A.end.toFixed(1)+' '+A.unit+' over 30 days">'
      +     '<defs><linearGradient id="rbfxLine" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#FF2A32"/><stop offset="1" stop-color="#ffb3b6"/></linearGradient>'
      +     '<linearGradient id="rbfxFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#FF2A32" stop-opacity=".24"/><stop offset="1" stop-color="#FF2A32" stop-opacity="0"/></linearGradient></defs>'
      +     yl + xl
      +     '<path class="rbfx-area" data-rb-area d="'+dArea+'" style="opacity:0"></path>'
      +     '<path class="rbfx-trace" data-rb-trace d="'+dFull+'"></path>'
      +     '<circle class="rbfx-dot" data-rb-dot cx="'+endX.toFixed(1)+'" cy="'+endY.toFixed(1)+'" r="7" style="opacity:0"></circle>'
      +   '</svg>'
      + '</div></div>';

    var old = wrap.querySelector(".nura__scope");       if (old) old.style.display="none";
    var of  = wrap.querySelector(".nura__scope-foot");  if (of) of.style.display="none";
    wrap.insertAdjacentHTML("afterbegin", html);

    var root=wrap.querySelector("[data-rbfx]");
    var trace=root.querySelector("[data-rb-trace]"), area=root.querySelector("[data-rb-area]");
    var dot=root.querySelector("[data-rb-dot]"), dEl=root.querySelector("[data-rb-delta]");
    var LEN=0; try{ LEN=trace.getTotalLength(); }catch(e){ LEN=900; }
    trace.style.strokeDasharray=LEN; trace.style.strokeDashoffset=LEN;

    function setT(t){
      t=Math.max(0,Math.min(1,t)); var e=easeOut(t);
      trace.style.strokeDashoffset=(LEN*(1-e)).toFixed(1);
      area.style.opacity=(e*e).toFixed(3);
      dot.style.opacity=(t>0.82?(t-0.82)/0.18:0).toFixed(3);
      dEl.textContent="-"+(delta*e).toFixed(1)+" "+A.unit;
    }
    function reset(){ setT(0); }
    var raf=0, t0=0, DUR=1700, running=false;
    function run(ts){ if(!t0)t0=ts; var t=(ts-t0)/DUR; setT(t); if(t<1){ raf=requestAnimationFrame(run); } else { running=false; } }
    function play(){ if(running)return; running=true; t0=0; cancelAnimationFrame(raf); raf=requestAnimationFrame(run); }
    reset();
    try{
      new IntersectionObserver(function(es){ es.forEach(function(e){
        if(e.isIntersecting) play(); else { cancelAnimationFrame(raf); running=false; reset(); }
      }); },{threshold:.3}).observe(root);
    }catch(e){ setT(1); }
  }

  /* ---------- clamp the concern-select scroll so the explanatory text stays visible ---------- */
  function clampScroll(){
    document.addEventListener("click", function(e){
      var chip = e.target.closest && e.target.closest(".nura__cs-chip");
      if(!chip) return;
      var cs = document.querySelector(".nura__cs"); if(!cs) return;
      var cases = document.querySelector(".nura__cases");
      requestAnimationFrame(function(){
        var anchor = cases || cs.querySelector(".nura__cs-panels") || cs;
        var rect = anchor.getBoundingClientRect();
        var clampMax = window.scrollY + rect.top - window.innerHeight*0.58;
        if (clampMax < 0) clampMax = 0;
        var orig = window.scrollTo;
        window.scrollTo = function(a,b){
          if (typeof a === "object" && a){ if (a.top>clampMax) a=Object.assign({},a,{top:clampMax}); return orig.call(window,a); }
          if (b>clampMax) b=clampMax;
          return orig.call(window,a,b);
        };
        setTimeout(function(){ window.scrollTo = orig; }, 1000);
      });
    }, true);
  }

  /* ---------- crossed-out compare-at price on each Standard/Pro card ---------- */
  function rbMoney(cents){ return "$" + (cents/100).toFixed(2); }
  function tierCents(card){
    var ver = card.getAttribute("data-ver") || "";
    var price = card.querySelector(".nbvc__price");
    var fromText = price ? Math.round((parseFloat((price.textContent||"").replace(/[^0-9.]/g,""))||0)*100) : 0;
    if (fromText) return fromText;
    try{
      var vs = ShopifyAnalytics.meta.product.variants, rx = (/pro/i.test(ver)) ? /\bpro\b/i : /standard/i;
      for (var i=0;i<vs.length;i++){ var nm=vs[i].name||vs[i].public_title||""; if (rx.test(nm)) return vs[i].price; }
    }catch(e){}
    return 0;
  }
  function compareAt(){
    document.querySelectorAll(".nbvc .nbvc__card").forEach(function(card){
      var legacy = card.querySelector(".rbfx-tier"); if (legacy) legacy.remove();
      var price = card.querySelector(".nbvc__price"); if (!price) return;
      var cents = tierCents(card); if (!cents) return;
      if (!price.textContent.trim()) price.textContent = rbMoney(cents);
      var want = rbMoney(cents*2);
      var cmp = card.querySelector(".rbfx-cmp");
      if (cmp){ if (cmp.textContent !== want) cmp.textContent = want; return; }
      cmp = document.createElement("span"); cmp.className = "rbfx-cmp"; cmp.textContent = want;
      price.parentNode.insertBefore(cmp, price);
    });
  }
  var rbNbvcWatched = false;
  function watchNbvc(){
    var vc = document.querySelector(".nbvc"); if (!vc) return;
    compareAt();
    if (rbNbvcWatched) return; rbNbvcWatched = true;
    try{ new MutationObserver(function(){ compareAt(); }).observe(vc, {childList:true, subtree:true, characterData:true}); }catch(e){}
  }

  /* ---------- fix handle-derived buy-box copy on duplicate products ("your waist" -> area) ---------- */
  function fixCopy(){
    var k = areaKey(); if (k === "waist") return;
    var word = { neck:"neck", thigh:"thighs", arm:"arms", portable:"body" }[k]; if (!word) return;
    document.querySelectorAll(".nbbul li, .nbbul span, .nbbul p").forEach(function(el){
      if (el.children.length === 0 && /your waist\b/i.test(el.textContent)){
        el.textContent = el.textContent.replace(/your waist\b/i, "your " + word);
      }
    });
  }

  /* ---------- reveal the header nav on scroll-up (theme's native sticky is broken in the section group) ---------- */
  function revealNav(){
    var sh = document.querySelector(".section-header"); if (!sh || sh.__rbnav) return; sh.__rbnav = 1;
    var lastY = window.scrollY || 0, baseH = sh.offsetHeight || 120;
    function set(hidden, stuck){
      sh.style.setProperty("transform", hidden ? "translateY(-110%)" : "none", "important");
      sh.style.boxShadow = stuck ? "0 10px 30px -20px rgba(0,0,0,.45)" : "none";
    }
    function onScroll(){
      var y = window.scrollY || 0;
      if (y <= baseH*0.7){ set(false, false); lastY = y; return; }  /* near top: normal */
      if (y > lastY + 4) set(true, true);          /* scrolling down -> hide */
      else if (y < lastY - 4) set(false, true);    /* scrolling up -> reveal */
      lastY = y;
    }
    window.addEventListener("scroll", onScroll, {passive:true});
    onScroll();
  }

  /* ---------- nura-story content edits (per the brand's requests) ---------- */
  function storyEdits(){
    if (!document.querySelector(".nura__mods, .nphase, .nsurvey")) return;

    /* 1. each therapy module → specific per-modality "what you'll see" bullets */
    var THER = [
      ["Smoother, more even skin texture","Fades redness, dullness & crepiness","Switches fresh collagen back on"],
      ["Visibly tighter, lifted skin","Re-firms where skin had gone slack","A sharper, more defined contour"],
      ["Rebuilds the deep collagen scaffold","Denser, springier skin over time","Firmness that keeps compounding"],
      ["Boosts circulation & lymphatic drainage","Triggers lipolysis — releases stored fat","Less bloat, puffiness & a slimmer look"]
    ];
    document.querySelectorAll(".nura__mod").forEach(function(m,i){
      var b = m.querySelector(".nura__mod-benefit");
      if (!b || !THER[i] || b.dataset.rb) return; b.dataset.rb = 1;
      b.innerHTML = '<span class="rbfx-wys">What you’ll see</span><ul class="rbfx-tlist">'+THER[i].map(function(x){return "<li>"+x+"</li>";}).join("")+"</ul>";
    });

    /* 2. 30-day progress → distinct, concrete week-by-week */
    var WK = [
      {t:"First sessions", b:["Warmth floods in — circulation kicks off within minutes","Bloat and puffiness start to drop","Skin feels tighter straight after each session"]},
      {t:"Firming kicks in", b:["Collagen ramps up — firmer to the touch","The first real smoothing shows up","Deep heat starts working the stubborn layer"]},
      {t:"You see it in the mirror", b:["Visible tightening and a more defined contour","Clothes start sitting looser where it counts","It’s a daily ritual now — results compound"]},
      {t:"A different body", b:["Firmer, smoother and noticeably lifted","Inches down — a smaller notch on the belt","You feel it now, not just see it"]}
    ];
    document.querySelectorAll(".nphase__row").forEach(function(r,i){
      if (!WK[i] || r.dataset.rb) return; r.dataset.rb = 1;
      var t = r.querySelector(".nphase__t"), ul = r.querySelector(".nphase__list");
      if (t) t.textContent = WK[i].t;
      if (ul) ul.innerHTML = WK[i].b.map(function(x){return "<li>"+x+"</li>";}).join("");
    });

    /* 3. "30 days in" survey → emotional / real-life outcomes (keep the count-up %) */
    var SURV = [
      ["Felt like themselves again","Their spark came back"],
      ["More confident","At ease in their own skin"],
      ["Clothes fit better","Jeans, dresses — the lot"],
      ["Stopped hiding their body","Ditched the baggy layers"],
      ["Looked forward to it","20 minutes that are just theirs"],
      ["Proud they kept going","A habit that finally stuck"]
    ];
    document.querySelectorAll(".nscard").forEach(function(c,i){
      if (!SURV[i] || c.dataset.rb) return; c.dataset.rb = 1;
      var t = c.querySelector(".nscard__t"), d = c.querySelector(".nscard__d");
      if (t) t.textContent = SURV[i][0];
      if (d) d.textContent = SURV[i][1];
    });

    /* 4. remove the "RubyBeam is a three-step system … to work" lead (red light is only step 2) */
    document.querySelectorAll(".nura__lead--c, .nura__lead").forEach(function(p){
      if (/three-step system/i.test(p.textContent||"")) p.remove();
    });

    /* 5. replace "Six reasons it actually works" with a how-it-works / science block */
    var h = [].slice.call(document.querySelectorAll(".nura__h2")).filter(function(e){ return /reasons it actually works|six reasons/i.test(e.textContent||""); })[0];
    if (h){
      var band = h.closest(".nura__band") || h.closest("section");
      if (band && !band.dataset.rbsci){
        band.dataset.rbsci = 1;
        band.innerHTML =
          '<div class="rbfx-sci">'
          + '<span class="nura__ey nura__ey--red">The science</span>'
          + '<h2 class="nura__h2">Why it actually works</h2>'
          + '<p class="nura__lead">Three clinical technologies, one 20-minute session. Here’s what’s happening under the skin — and why it holds.</p>'
          + '<ul class="rbfx-sci-list">'
          + '<li><b>Red &amp; near-infrared light (660&nbsp;nm + 850&nbsp;nm)</b> reaches the dermis and switches on your cells’ mitochondria — photobiomodulation — driving fresh collagen and elastin.</li>'
          + '<li><b>Galvanic micro-current</b> re-educates the muscle wall and firms slack skin from the inside out.</li>'
          + '<li><b>Far-infrared heat</b> raises the deep-tissue temperature to boost circulation and trigger lipolysis — the release of stored fat.</li>'
          + '<li><b>Creams sit on the surface.</b> This rebuilds from the deep layer up — which is why the results keep compounding instead of washing off.</li>'
          + '</ul>'
          + '<a class="rbfx-sci-link" href="/pages/studies">See the clinical studies →</a>'
          + '</div>';
      }
    }

    /* 6. give-back / Humane League panel: beige → white */
    var give = [].slice.call(document.querySelectorAll(".shopify-section, section")).filter(function(s){ return /humane league/i.test(s.textContent||"") && s.children.length < 8; })[0];
    if (give) give.querySelectorAll("*").forEach(function(e){
      var bg = getComputedStyle(e).backgroundColor, m = bg.match(/rgba?\((\d+), (\d+), (\d+)/);
      if (m){ var r=+m[1],g=+m[2],b=+m[3]; if (r>235 && r<252 && b<246 && r>=b && !(r>250&&g>250&&b>250)) e.style.background = "#fff"; }
    });
  }

  /* ---------- portable Sculptor: tailor the waist/wrap story copy to the handheld all-body device ---------- */
  function tailorPortable(){
    if (areaKey() !== "portable") return;
    /* buy-box bullet: "hands-free" is a wrap claim — this one is cordless/handheld */
    document.querySelectorAll(".nbbul li").forEach(function(li){
      if (li.children.length===0 && /hands-free/i.test(li.textContent) && !li.dataset.rbp){
        li.dataset.rbp=1; li.textContent = li.textContent.replace(/,\s*hands-free/i, " — cordless & portable");
      }
    });
    /* 60-day guarantee headline: waist -> body */
    var gt=document.querySelector(".nura__gtitle");
    if (gt && /tighter waist/i.test(gt.textContent) && !gt.dataset.rbp){ gt.dataset.rbp=1; gt.textContent=gt.textContent.replace(/tighter waist/i,"tighter body"); }
    /* concern selector: belly-only concerns -> whole-body areas (chip text + matching panel) */
    var CH=[
      ["Belly & waist","Flatten the belly that won’t budge","Far-infrared heat and galvanic micro-current work the deep, stubborn layer around your core that diet and cardio leave behind, while red light firms the skin above it.","86% saw a flatter, more toned waist in 30 days"],
      ["Arms & bingo wings","Firm up soft, swinging upper arms","Glide the sculptor along the back of each arm — red light rebuilds collagen while micro-current re-firms the slack muscle wall, so arms look toned, not loose.","84% saw firmer, tighter arms in 30 days"],
      ["Thighs & cellulite","Smooth cellulite, firm the thighs","Far-infrared heat boosts circulation to break up the dimpled, stubborn layer while red light and micro-current firm and smooth the skin across thighs and hips.","81% saw smoother thighs with less cellulite"],
      ["Neck & jawline","Lift the neck, sharpen the jaw","Sculpt along the jaw and down the neck — red light and galvanic current tighten crepey skin and lift the contour where age and screens show first.","88% saw a firmer neck & jawline in 30 days"],
      ["Back & bra bulge","Smooth the back & bra line","Work the sculptor across the bra line and back — deep heat and micro-current firm the skin and soften the rolls that bras and tops dig into.","79% saw a smoother back & bra line"],
      ["Loose, crepey skin","Rebuild crepey skin anywhere","Thin, crepey skin on arms, knees, décolleté or belly gets the same 660nm red light that switches collagen back on — firmer, denser, smoother wherever you treat.","85% reported firmer, less crepey skin"]
    ];
    document.querySelectorAll(".nura__cs-chip").forEach(function(c,i){ if(CH[i]&&!c.dataset.rbp){ c.dataset.rbp=1; c.textContent=CH[i][0]; }});
    document.querySelectorAll(".nura__cs-panel").forEach(function(p,i){
      if(!CH[i]||p.dataset.rbp) return; p.dataset.rbp=1;
      var h=p.querySelector(".nura__cs-h"), d=p.querySelector(".nura__cs-p"), s=p.querySelector(".nura__cs-stat");
      if(h) h.textContent=CH[i][1]; if(d) d.textContent=CH[i][2];
      if(s) s.innerHTML='<span class="nura__cs-dot"></span>'+CH[i][3];
    });
    /* "Swipe through the waist concerns" -> "the concerns" */
    document.querySelectorAll("p.nura__lead, .nura__lead--c").forEach(function(p){
      if(/waist concerns/i.test(p.textContent) && !p.dataset.rbp){ p.dataset.rbp=1; p.textContent=p.textContent.replace(/the waist concerns/i,"the concerns"); }
    });
    /* 3-step: step 2 image (band) -> the sculptor, and its title */
    var stepImg=[].slice.call(document.querySelectorAll(".nura__step3 img")).filter(function(im){return /sys-band/.test(im.src);})[0];
    if(stepImg && !stepImg.dataset.rbp){ stepImg.dataset.rbp=1; stepImg.src="https://cdn.shopify.com/s/files/1/1117/4900/5650/files/hf_20261022_041835_d3f77cf0-6466-4d3b-81ca-64c014679998.png?v=1792643306"; stepImg.removeAttribute("srcset"); stepImg.alt="The RubyBeam Sculptor — handheld red-light device"; }
    document.querySelectorAll(".nura__step3 h3").forEach(function(h){ if(/The RubyBeam Wrap/i.test(h.textContent) && !h.dataset.rbp){ h.dataset.rbp=1; h.textContent="The RubyBeam Sculptor"; }});
    /* "wrap" wording -> "sculptor"/"handheld tool" */
    function repl(sel, re, to){ document.querySelectorAll(sel).forEach(function(e){ if(e.children.length===0 && re.test(e.textContent) && !e.dataset.rbw){ e.dataset.rbw=1; e.textContent=e.textContent.replace(re,to);} }); }
    document.querySelectorAll(".nura__h2").forEach(function(e){
      if(/engineered wrap/i.test(e.textContent) && !e.dataset.rbw){ e.dataset.rbw=1; e.innerHTML=e.innerHTML.replace(/engineered wrap/i,"handheld sculptor"); }
      if(/put the clinic in a wrap/i.test(e.textContent) && !e.dataset.rbw2){ e.dataset.rbw2=1; e.innerHTML=e.innerHTML.replace(/in a wrap/i,"in your hand"); }
    });
    repl("p.nura__evid-note", /into a wrap you use at home/i, "into a handheld tool you use at home");
    repl("p", /the wrap has nothing to transfer into/i, "the sculptor has nothing to transfer into");
    repl("p", /Your RubyBeam wrap,/i, "Your RubyBeam sculptor,");
    repl("p", /one engineered wrap/i, "one handheld sculptor");
    document.querySelectorAll("p").forEach(function(e){
      if(e.children.length!==0) return;
      if(/velcro strap cinches/i.test(e.textContent) && !e.dataset.rbw){ e.dataset.rbw=1;
        e.textContent="It’s fully cordless and handheld — no straps, no sizing. Charge it, switch it on and glide it over any area for about 20 minutes, then move to the next.";
      }
      if(/engineered system, not a device/i.test(e.textContent) && /\bwrap\b/i.test(e.textContent) && !e.dataset.rbw3){ e.dataset.rbw3=1; e.textContent=e.textContent.replace(/\bwrap\b/i,"sculptor"); }
    });
    /* "Proof, problem by problem" before/after carousel: belly-only -> whole-body.
       case 0 stays belly (relabel), 1-3 become arms/thighs/neck with new before/after photos, 4+ hidden. */
    var RBCDN="https://cdn.shopify.com/s/files/1/1117/4900/5650/files/";
    var BA=[null,
      {tag:"Arms & bingo wings", b:"ba-arm-before.png?v=1792686585", a:"ba-arm-after.png?v=1792686585"},
      {tag:"Thighs & cellulite", b:"ba-thigh-before.png?v=1792686585", a:"ba-thigh-after.png?v=1792686585"},
      {tag:"Neck & jawline", b:"ba-neck-before.png?v=1792686585", a:"ba-neck-after.png?v=1792686585"},
      {tag:"Back & bra bulge", b:"ba-back-before.png?v=1792688477", a:"ba-back-after.png?v=1792688477"},
      {tag:"Loose, crepey skin", b:"ba-crepey-before.png?v=1792688476", a:"ba-crepey-after.png?v=1792688477"}];
    document.querySelectorAll(".nura__case").forEach(function(cs,i){
      if(cs.dataset.rbp) return;
      var tag=cs.querySelector(".nura__case-tag"), imgs=cs.querySelectorAll("img");
      if(i===0){ cs.dataset.rbp=1; if(tag) tag.textContent="Belly & waist"; return; }
      if(BA[i]){ cs.dataset.rbp=1; cs.style.display=""; if(tag) tag.textContent=BA[i].tag;
        if(imgs[0]){ imgs[0].removeAttribute("srcset"); imgs[0].src=RBCDN+BA[i].b; imgs[0].alt=BA[i].tag+" before"; }
        if(imgs[1]){ imgs[1].removeAttribute("srcset"); imgs[1].src=RBCDN+BA[i].a; imgs[1].alt=BA[i].tag+" after"; }
        return; }
      cs.dataset.rbp=1; cs.style.display="none";
    });
    /* link the concern selector to the proof: selecting a concern scrolls the carousel to its before/after */
    if(!document.body.dataset.rbCsLink){
      document.body.dataset.rbCsLink="1";
      document.addEventListener("click", function(e){
        var chip=e.target.closest && e.target.closest(".nura__cs-chip"); if(!chip) return;
        var chips=[].slice.call(document.querySelectorAll(".nura__cs-chip"));
        var idx=chips.indexOf(chip); if(idx<0) return;
        var cases=[].slice.call(document.querySelectorAll(".nura__case")).filter(function(c){return c.style.display!=="none";});
        var target=cases[Math.min(idx,cases.length-1)]; var wrap=document.querySelector(".nura__cases");
        if(target && wrap){ setTimeout(function(){ try{ var dl=target.getBoundingClientRect().left-wrap.getBoundingClientRect().left-14; wrap.scrollTo({left:Math.max(0,wrap.scrollLeft+dl),behavior:"smooth"}); }catch(err){ try{wrap.scrollLeft=target.offsetLeft;}catch(e2){} } }, 140); }
      }, true);
    }
    /* leftover waist lifestyle band image -> the sculptor in use */
    [].slice.call(document.querySelectorAll("img")).forEach(function(im){
      if(/lifestyle-waist/.test(im.src||"") && !im.dataset.rbp){ im.dataset.rbp=1; im.removeAttribute("srcset"); im.src=RBCDN+"sc-lifestyle-device.png?v=1792686656"; }
    });
    /* "Real women. Real results." testimonial photos still showed the waist wrap -> device-UGC selfies */
    var UGC=[RBCDN+"ugc-device-1.png?v=1792689657", RBCDN+"ugc-device-2.png?v=1792689657", RBCDN+"ugc-device-3.png?v=1792689658", RBCDN+"ugc-device-4.png?v=1792689656"];
    document.querySelectorAll(".nsp__card .nsp__ph img").forEach(function(im,i){
      if(UGC[i] && !im.dataset.rbp){ im.dataset.rbp=1; im.removeAttribute("srcset"); im.src=UGC[i]; }
    });
  }

  /* ---------- LymphaFlow belt: reframe the waist story around heavy vibration + lymphatic drainage ---------- */
  function tailorLymph(){
    if (areaKey() !== "lymph") return;
    var RBCDN="https://cdn.shopify.com/s/files/1/1117/4900/5650/files/";

    /* buy-box bullets -> lead with drainage */
    var BUL=["Deep lymphatic drainage — flushes bloat & trapped fluid",
             "A visibly flatter, de-bloated, slimmer waist",
             "Powerful vibration + Red & Near-Infrared light, hands-free"];
    document.querySelectorAll(".nbbul li").forEach(function(li,i){
      if(BUL[i] && li.children.length===0 && !li.dataset.rbl){ li.dataset.rbl=1; li.textContent=BUL[i]; }
    });
    /* 60-day guarantee headline */
    var gt=document.querySelector(".nura__gtitle");
    if(gt && !gt.dataset.rbl){ gt.dataset.rbl=1; gt.textContent="See a flatter, de-bloated waist in 60 days — or your money back"; }

    /* concern selector -> drainage concerns */
    var CH=[
      ["Bloating & water weight","Flush the bloat that puffs you out","Deep vibration wakes your lymphatic system and drives out the trapped fluid and water weight that make your belly swell — so you de-bloat and your waist flattens, fast.","92% felt less bloated within 30 days"],
      ["Stubborn lower-belly pouch","Work the pouch that won't shift","Vibration and far-infrared warmth boost circulation and drainage deep in the lower-belly layer while red light firms the skin above — targeting the pouch diet and cardio leave behind.","86% saw a flatter lower belly in 30 days"],
      ["Post-pregnancy belly","Drain, firm and close the gap","Gentle deep vibration moves trapped fluid out of a soft post-baby tummy while red + near-infrared light rebuilds collagen to firm and tighten the skin — at your own pace.","84% felt firmer, flatter after 30 days"],
      ["Menopause & hormonal belly","Beat the belly that came with the hormones","A 20-minute drainage session flushes the fluid behind hormonal and menopause bloating and heat works the stubborn midsection — so you feel lighter and less puffy.","85% felt lighter and less bloated"],
      ["Love handles & muffin top","Smooth the sides that spill over","The belt wraps your whole core, so vibration and red light drain and firm the sides too — softening the love handles and muffin top that push over your waistband.","83% saw a smoother, tighter waistline"],
      ["Soft, crepey core skin","Firm crepey skin on the belly","Red 660nm and near-infrared 850nm light switch collagen back on in the skin across your belly and waist — firmer, denser and smoother on top of a drained, flatter core.","85% reported firmer skin on the waist"]
    ];
    document.querySelectorAll(".nura__cs-chip").forEach(function(c,i){ if(CH[i]&&!c.dataset.rbl){ c.dataset.rbl=1; c.textContent=CH[i][0]; }});
    document.querySelectorAll(".nura__cs-panel").forEach(function(p,i){
      if(!CH[i]||p.dataset.rbl) return; p.dataset.rbl=1;
      var h=p.querySelector(".nura__cs-h"), d=p.querySelector(".nura__cs-p"), s=p.querySelector(".nura__cs-stat");
      if(h) h.textContent=CH[i][1]; if(d) d.textContent=CH[i][2];
      if(s) s.innerHTML='<span class="nura__cs-dot"></span>'+CH[i][3];
    });

    /* 3-step: step 2 (the band) -> the LymphaFlow belt */
    var stepImg=[].slice.call(document.querySelectorAll(".nura__step3 img")).filter(function(im){return /sys-band/.test(im.src);})[0];
    if(stepImg && !stepImg.dataset.rbl){ stepImg.dataset.rbl=1; stepImg.src=RBCDN+"lf-belt-clean.png?v=1792693229"; stepImg.removeAttribute("srcset"); stepImg.alt="The RubyBeam LymphaFlow belt"; }
    document.querySelectorAll(".nura__step3 h3").forEach(function(h){ if(/The RubyBeam Wrap/i.test(h.textContent)&&!h.dataset.rbl){ h.dataset.rbl=1; h.textContent="The LymphaFlow Belt"; }});

    /* technology section: feature heavy vibration */
    document.querySelectorAll(".nura__mod").forEach(function(m,i){
      var h3=m.querySelector(".nura__mod-h h3"), copy=m.querySelector("p:not(.nura__mod-benefit)"), spec=m.querySelector(".nura__mod-spec"), ben=m.querySelector(".nura__mod-benefit");
      if(i===1 && h3 && !h3.dataset.rbl){ h3.dataset.rbl=1; h3.textContent="Deep Lymphatic Vibration";
        if(copy) copy.textContent="Multiple high-frequency motors send powerful vibration deep into your core, waking up the lymphatic system and pushing trapped fluid, bloat and waste out — the drainage that drives every other result.";
        if(spec) spec.innerHTML="<span>Up to 3,000 RPM</span><span>Multi-motor</span><span>5 intensity modes</span>";
      }
      var MB=[
        ["Smoother, firmer skin on the waist","Fades crepiness over the belly","Switches fresh collagen back on"],
        ["Flushes bloat & trapped fluid","A flatter, de-bloated waist fast","Less water weight and puffiness"],
        ["Rebuilds the deep collagen scaffold","Firmer, springier belly skin","Firmness that keeps compounding"],
        ["Boosts circulation & lymph flow","Warms and loosens the stubborn layer","Less heaviness, a lighter middle"]
      ];
      if(ben && MB[i] && !ben.dataset.rbl){ ben.dataset.rbl=1;
        ben.innerHTML='<span class="rbfx-wys">What you’ll see</span><ul class="rbfx-tlist">'+MB[i].map(function(x){return "<li>"+x+"</li>";}).join("")+"</ul>";
      }
    });
    /* section heading + "clinic in a wrap" -> belt */
    document.querySelectorAll(".nura__h2").forEach(function(e){
      if(/engineered wrap/i.test(e.textContent)&&!e.dataset.rbl){ e.dataset.rbl=1; e.innerHTML=e.innerHTML.replace(/Four clinical therapies/i,"Vibration + red light").replace(/engineered wrap/i,"engineered belt"); }
      if(/in a wrap/i.test(e.textContent)&&!e.dataset.rbl2){ e.dataset.rbl2=1; e.innerHTML=e.innerHTML.replace(/in a wrap/i,"in a belt"); }
    });
    /* deep copy: product-noun "wrap" -> "belt" (leave the verb "cinches to wrap snugly"); galvanic -> vibration in the tech summary */
    function replL(re,to){ document.querySelectorAll("p").forEach(function(e){ if(e.children.length===0 && re.test(e.textContent) && !e.dataset.rbw){ e.dataset.rbw=1; e.textContent=e.textContent.replace(re,to);} }); }
    replL(/the wrap has nothing to transfer into/i, "the belt has nothing to transfer into");
    replL(/the wrap then drives/i, "the belt then drives");
    replL(/Your RubyBeam wrap,/i, "Your RubyBeam belt,");
    var en=document.querySelector(".nura__evid-note");
    if(en && !en.dataset.rbw){ en.dataset.rbw=1; en.innerHTML=en.innerHTML.replace(/into a wrap you use at home/i,"into a belt you use at home").replace(/galvanic firming/i,"deep vibration"); }
    /* re-skin the injected "Why it actually works" science block for the belt */
    var sci=document.querySelector(".rbfx-sci-list");
    if(sci && !sci.dataset.rbl){ sci.dataset.rbl=1;
      sci.innerHTML=
        '<li><b>Powerful vibration</b> wakes up a sluggish lymphatic system and physically moves trapped fluid, bloat and waste out of your core — the drainage that makes your waist look flatter and lighter.</li>'
      + '<li><b>Red &amp; near-infrared light (660&nbsp;nm + 850&nbsp;nm)</b> reaches the dermis, firing collagen and elastin so the skin over your belly firms and tightens.</li>'
      + '<li><b>Far-infrared warmth</b> raises the deep-tissue temperature to boost circulation and loosen the stubborn layer — so drainage works faster.</li>'
      + '<li><b>Better drainage is the engine.</b> Flush the fluid first and the de-bloating, slimming and firming all follow — which is why results keep compounding.</li>';
    }
    var scilead=[].slice.call(document.querySelectorAll(".rbfx-sci .nura__lead, .nura__lead")).filter(function(p){return /three clinical technologies/i.test(p.textContent);})[0];
    if(scilead && !scilead.dataset.rbl){ scilead.dataset.rbl=1; scilead.textContent="Heavy vibration plus clinical light, in one 20-minute session. Here’s what’s happening under the skin — and why the results hold."; }

    /* "Proof, problem by problem" -> 3 de-bloat before/afters; hide the rest */
    var BA=[
      {tag:"Bloating & water retention", b:"ba-lf-bloat-before.png?v=1792693227", a:"ba-lf-bloat-after.png?v=1792693227"},
      {tag:"Love handles & muffin top", b:"ba-lf-love-before.png?v=1792693227", a:"ba-lf-love-after.png?v=1792693227"},
      {tag:"Post-meal & water puffiness", b:"ba-lf-water-before.png?v=1792693227", a:"ba-lf-water-after.png?v=1792693226"}
    ];
    document.querySelectorAll(".nura__case").forEach(function(cs,i){
      if(cs.dataset.rbl) return; cs.dataset.rbl=1;
      var tag=cs.querySelector(".nura__case-tag"), imgs=cs.querySelectorAll("img");
      if(BA[i]){ cs.style.display=""; if(tag) tag.textContent=BA[i].tag;
        if(imgs[0]){ imgs[0].removeAttribute("srcset"); imgs[0].src=RBCDN+BA[i].b; imgs[0].alt=BA[i].tag+" before"; }
        if(imgs[1]){ imgs[1].removeAttribute("srcset"); imgs[1].src=RBCDN+BA[i].a; imgs[1].alt=BA[i].tag+" after"; }
      } else { cs.style.display="none"; }
    });
    /* concern -> proof linkage (6 chips -> 3 cases) */
    if(!document.body.dataset.rbLfLink){
      document.body.dataset.rbLfLink="1";
      var CSMAP=[0,0,0,2,1,0];
      document.addEventListener("click", function(e){
        var chip=e.target.closest && e.target.closest(".nura__cs-chip"); if(!chip) return;
        var chips=[].slice.call(document.querySelectorAll(".nura__cs-chip"));
        var idx=chips.indexOf(chip); if(idx<0) return;
        var cases=[].slice.call(document.querySelectorAll(".nura__case")).filter(function(c){return c.style.display!=="none";});
        var ci=(CSMAP[idx]!=null)?CSMAP[idx]:Math.min(idx,cases.length-1);
        var target=cases[Math.min(ci,cases.length-1)]; var wrap=document.querySelector(".nura__cases");
        if(target&&wrap){ setTimeout(function(){ try{ var dl=target.getBoundingClientRect().left-wrap.getBoundingClientRect().left-14; wrap.scrollTo({left:Math.max(0,wrap.scrollLeft+dl),behavior:"smooth"}); }catch(err){ try{wrap.scrollLeft=target.offsetLeft;}catch(e2){} } }, 140); }
      }, true);
    }

    /* leftover waist lifestyle band image -> the belt worn; tech-section cutaway -> the belt cutaway */
    [].slice.call(document.querySelectorAll("img")).forEach(function(im){
      if(/lifestyle-waist/.test(im.src||"")&&!im.dataset.rbl){ im.dataset.rbl=1; im.removeAttribute("srcset"); im.src=RBCDN+"lf-real-1.png?v=1792696356"; }
      if(/tech-cutaway/.test(im.src||"")&&!im.dataset.rbl){ im.dataset.rbl=1; im.removeAttribute("srcset"); im.src=RBCDN+"lf-cutaway.png?v=1792694284"; im.alt="Cutaway of the LymphaFlow belt — vibration motor, red & near-infrared LED array, neoprene shell"; }
    });
    /* testimonial photos -> clean premium shots of women wearing the belt */
    var UGC=[RBCDN+"lf-real-1.png?v=1792696356", RBCDN+"lf-real-2.png?v=1792696356", RBCDN+"lf-real-3.png?v=1792696357", RBCDN+"lf-real-4.png?v=1792696357"];
    document.querySelectorAll(".nsp__card .nsp__ph img").forEach(function(im,i){
      if(UGC[i]&&!im.dataset.rbl){ im.dataset.rbl=1; im.removeAttribute("srcset"); im.src=UGC[i]; }
    });
  }

  /* ---------- cart: "Expedited Processing" ($9.99) toggle above checkout — added ONLY on checkout click ----------
     Shows the product image + an on/off switch (default ON, sticky via localStorage rb_exped). The toggle does NOT
     touch the cart; when the customer clicks Check out with it ON, the variant is added, then we proceed to checkout. */
  var RB_EXPED=55071858098514;
  var RB_EXPED_IMG="https://cdn.shopify.com/s/files/1/1117/4900/5650/files/expedited-processing.png?v=1792683855";
  var rbShipObsSet=false, rbShipDeb=0;
  function rbShipPref(){ try{ var p=localStorage.getItem("rb_exped"); return p===null?"1":p; }catch(e){ return "1"; } }
  /* The expedited variant must NEVER sit in the cart as a visible line — it is added only at the checkout click.
     If a customer abandons checkout and returns, it can linger in the cart, so strip it on every store-page load. */
  var rbExpedChecked=false;
  function rbHideExpedLine(){
    try{ var rows=document.querySelectorAll("tr.cart-item, .cart-item, .cart-drawer-item, cart-drawer-item");
      for(var i=0;i<rows.length;i++){ var row=rows[i];
        if(row.querySelector('img[src*="expedited-processing"]') || /Expedited Processing/i.test(row.textContent||"")){ row.style.display="none"; } } }catch(e){}
  }
  function rbStripExped(){
    if(rbExpedChecked) return; rbExpedChecked=true;
    fetch("/cart.js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(c){
      var present=c.items.some(function(i){return i.variant_id===RB_EXPED;});
      if(!present){ try{ sessionStorage.removeItem("rb_exstrip"); }catch(e){} return; }
      rbHideExpedLine();
      var did=false; try{ did=sessionStorage.getItem("rb_exstrip")==="1"; }catch(e){}
      fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:String(RB_EXPED),quantity:0})})
        .then(function(){ if(!did){ try{ sessionStorage.setItem("rb_exstrip","1"); }catch(e){} location.reload(); } }, function(){});
    }, function(){});
  }
  function rbShipCSS(){
    if(document.getElementById("rbship-css")) return;
    var s=document.createElement("style"); s.id="rbship-css";
    s.textContent=".cart__ctas{flex-direction:column !important;align-items:stretch !important;}.rbship{display:flex;align-items:center;gap:10px;padding:6px 11px;margin:0;border:1.5px solid #e3ddd3;border-radius:11px;background:#fff;}.rbship__img{width:34px;height:34px;border-radius:8px;object-fit:contain;background:#f6f3ee;flex:0 0 auto;padding:2px;}.rbship__m{flex:1 1 auto;min-width:0;text-align:left;}.rbship__t{display:flex;align-items:baseline;gap:6px;min-width:0;}.rbship__t b{font-size:12.5px;font-weight:800;color:#15110D;letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;}.rbship__t em{font-size:12px;font-weight:800;font-style:normal;color:#15110D;flex:0 0 auto;}.rbship__d{font-size:10.5px;color:#6f655c;margin-top:1px;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}.rbship__sw{position:relative;width:42px;height:25px;flex:0 0 auto;cursor:pointer;}.rbship__sw input{position:absolute;opacity:0;width:100%;height:100%;margin:0;cursor:pointer;z-index:2;}.rbship__sw i{position:absolute;inset:0;background:#d4cec4;border-radius:999px;transition:background .2s;}.rbship__sw i::after{content:'';position:absolute;top:3px;left:3px;width:19px;height:19px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.3);transition:transform .2s;}.rbship__sw input:checked + i{background:#2bbd5a;}.rbship__sw input:checked + i::after{transform:translateX(17px);}.nura-cart-trust{display:none !important;}.nura-cart-gift{padding:8px 12px !important;gap:9px !important;}.nura-cart-gift__thumbs img{width:30px !important;height:30px !important;}.nura-cart-gift__ck{width:20px !important;height:20px !important;flex:0 0 auto !important;}.nura-cart-gift__tx{font-size:11.5px !important;line-height:1.25 !important;}";
    document.head.appendChild(s);
  }
  function rbShipEnsureThenCheckout(){
    function go(){ window.location.href="/checkout"; }
    fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
      var present=c.items.some(function(i){return i.variant_id===RB_EXPED;});
      if(rbShipPref()==="1" && !present){
        fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:RB_EXPED,quantity:1}]})}).then(go, go);
      } else { go(); }
    }, go);
  }
  function rbShipBindCheckout(){
    document.querySelectorAll('.cart__ctas [name="checkout"], .cart__ctas .cart__checkout-button').forEach(function(btn){
      if(btn.dataset.rbbound) return; btn.dataset.rbbound="1";
      btn.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); rbShipEnsureThenCheckout(); }, true);
    });
  }
  function rbShipInject(){
    var ctas=document.querySelector(".cart__ctas"); if(!ctas) return;
    rbShipCSS();
    if(!ctas.querySelector(".rbship")){
      var on=rbShipPref()==="1";
      var el=document.createElement("div"); el.className="rbship";
      el.innerHTML='<img class="rbship__img" src="'+RB_EXPED_IMG+'" alt="Expedited Processing" width="50" height="50">'
        +'<div class="rbship__m"><div class="rbship__t"><b>Expedited Processing</b><em>$9.99</em></div>'
        +'<div class="rbship__d">Ships within 24 hours</div></div>'
        +'<label class="rbship__sw"><input type="checkbox"'+(on?" checked":"")+'><i></i></label>';
      ctas.insertBefore(el, ctas.firstChild);
      el.querySelector("input").addEventListener("change", function(){ try{ localStorage.setItem("rb_exped", this.checked?"1":"0"); }catch(e){} });
    }
    rbShipBindCheckout();
  }
  function rbShipTrigger(){ clearTimeout(rbShipDeb); rbShipDeb=setTimeout(cartUpsell,200); }
  function cartUpsell(){
    rbStripExped();
    if(!rbShipObsSet){ var cd=document.getElementById("CartDrawer")||document.querySelector("cart-drawer");
      if(cd){ rbShipObsSet=true; try{ new MutationObserver(rbShipTrigger).observe(cd,{childList:true,subtree:true}); }catch(e){} } }
    rbShipInject();
  }

  /* ---------- scroll-indicator dots + mobile sideways-swipe for the long PDP sections ---------- */
  function rbDotsCSS(){
    if(document.getElementById("rb-dots-css")) return;
    var s=document.createElement("style"); s.id="rb-dots-css";
    s.textContent=".rbdots{display:none;justify-content:center;gap:8px;margin:16px auto 0;padding:0;}.rbdot{width:8px;height:8px;padding:0;border:none;border-radius:50%;background:#d8d2c8;cursor:pointer;transition:width .25s,background .25s,border-radius .25s;-webkit-appearance:none;appearance:none;}.rbdot.on{background:#E4121B;width:22px;border-radius:4px;}@media (max-width:749px){.nura__mods{display:flex !important;flex-wrap:nowrap !important;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;gap:16px;scrollbar-width:none;padding-bottom:4px;}.nura__mods::-webkit-scrollbar{display:none;}.nura__mods>.nura__mod{flex:0 0 88% !important;scroll-snap-align:center;}}.nura__mod{display:flex;flex-direction:column;}.nura__mod .nura__diag{margin-top:auto;}";
    document.head.appendChild(s);
  }
  function rbDots(container, itemSel){
    if(!container) return;
    var items=[].slice.call(container.children).filter(function(c){return c.matches && c.matches(itemSel);});
    if(items.length<2) return;
    var overflow=container.scrollWidth > container.clientWidth+6;
    var dots=container.__rbdotsEl;
    if(!overflow){ if(dots) dots.style.display="none"; return; }
    if(!dots){
      dots=document.createElement("div"); dots.className="rbdots";
      items.forEach(function(it,i){
        var b=document.createElement("button"); b.type="button"; b.className="rbdot"+(i===0?" on":""); b.setAttribute("aria-label","Go to item "+(i+1));
        b.addEventListener("click",function(){ try{ var t=it.getBoundingClientRect().left-container.getBoundingClientRect().left+container.scrollLeft-16; container.scrollTo({left:Math.max(0,t),behavior:"smooth"}); }catch(e){ container.scrollLeft=it.offsetLeft; } });
        dots.appendChild(b);
      });
      container.parentNode.insertBefore(dots, container.nextSibling);
      container.__rbdotsEl=dots;
      container.addEventListener("scroll",function(){ var max=container.scrollWidth-container.clientWidth; var r=max>0?container.scrollLeft/max:0; var idx=Math.round(r*(items.length-1)); [].slice.call(dots.children).forEach(function(d,i){ d.className="rbdot"+(i===idx?" on":""); }); },{passive:true});
    }
    dots.style.display="flex";
  }
  function rbScrollDots(){ try{ rbDotsCSS(); }catch(e){} try{ rbDots(document.querySelector(".nura__steps3"),".nura__step3"); }catch(e){} try{ rbDots(document.querySelector(".nura__mods"),".nura__mod"); }catch(e){} }
  var rbDotsResizeBound=false;
  function rbDotsWatch(){ rbScrollDots(); if(!rbDotsResizeBound){ rbDotsResizeBound=true; var tmr; window.addEventListener("resize",function(){ clearTimeout(tmr); tmr=setTimeout(rbScrollDots,200); },{passive:true}); } }

  /* ---------- home page: product-title (Fraunces) font on the featured-collection titles ---------- */
  function homeFont(){
    var p=(location.pathname||"/");
    if(!(p==="/"||p==="")) return;
    if(document.getElementById("rb-home-font")) return;
    var s=document.createElement("style"); s.id="rb-home-font";
    s.textContent=".card__heading,.card__heading a,.card-information__text,.collection__title .title,.collection__title.title-wrapper .title{font-family:'Fraunces',Georgia,serif !important;font-weight:500 !important;letter-spacing:0 !important;text-transform:none !important;}";
    document.head.appendChild(s);
  }

  /* ---------- home hero: premium gold-star rating + animated 100k->700k+ customer counter ---------- */
  function rbhxCSS(){
    if(document.getElementById("rb-hero-css")) return;
    var s=document.createElement("style"); s.id="rb-hero-css";
    s.textContent=".nh2__tp{display:flex;flex-direction:column;gap:3px;}.rbhx-row{display:flex;align-items:center;gap:9px;flex-wrap:wrap;}.rbhx-stars{color:#E0A63E;letter-spacing:2.5px;font-size:18px;line-height:1;white-space:nowrap;}.rbhx-stat{font-family:'Hanken Grotesk',Archivo,-apple-system,sans-serif;font-size:15.5px;font-weight:600;color:#2a2520;letter-spacing:.01em;}.rbhx-stat b{font-weight:800;color:#15110D;font-variant-numeric:tabular-nums;}.rbhx-tp{font-family:'Hanken Grotesk',Archivo,sans-serif;font-size:12.5px;color:#8a817a;}@media(max-width:860px){.nh2__tp{align-items:center;}.rbhx-row{justify-content:center;}}";
    document.head.appendChild(s);
  }
  function homeHero(){
    var p=(location.pathname||"/"); if(!(p==="/"||p==="")) return;
    rbhxCSS();
    var tp=document.querySelector(".nh2__tp");
    if(!tp || tp.dataset.rbhx) return; tp.dataset.rbhx=1;
    tp.innerHTML='<div class="rbhx-row"><span class="rbhx-stars">★★★★★</span>'
      +'<span class="rbhx-stat"><b data-rbct>100,000</b>+ glowing customers</span></div>'
      +'<div class="rbhx-tp">Excellent · 3,015+ reviews on Trustpilot</div>';
    var el=tp.querySelector("[data-rbct]"); if(!el) return;
    var start=100000,end=700000,t0=0,DUR=2200;
    function fmt(n){ return Math.round(n).toLocaleString("en-US"); }
    function step(ts){ if(!t0)t0=ts; var t=Math.min(1,(ts-t0)/DUR); var e=1-Math.pow(1-t,3); el.textContent=fmt(start+(end-start)*e); if(t<1) requestAnimationFrame(step); else el.textContent=fmt(end); }
    requestAnimationFrame(step);
  }

  /* ---------- Force subscription: silently attach each product's Refill Plan selling plan to the cart (no UI) ---------- */
  var rbSubCache={};
  function subEnsure(form, planId){
    var inp=form.querySelector('input[name="selling_plan"]');
    if(!inp){ inp=document.createElement("input"); inp.type="hidden"; inp.name="selling_plan"; form.appendChild(inp); }
    if(inp.value!==String(planId)) inp.value=planId;
  }
  function subDefault(){
    var p=(location.pathname||"");
    if(p.indexOf("/products/")===-1) return;
    /* the real product form is the one the add-to-cart button submits (button.form),
       NOT necessarily the first form[action*=/cart/add] on the page */
    var atc=document.querySelector('.product-form__submit, button[name="add"][type="submit"]');
    if(!atc) return;
    var form=atc.form || atc.closest('form[action*="/cart/add"]');
    if(!form || !/\/cart\/add/.test(form.action||"")) return;
    var handle=(p.split("/products/")[1]||"").split("/")[0].split("?")[0];
    if(!handle) return;
    if(rbSubCache[handle]!==undefined){
      if(rbSubCache[handle]) subEnsure(form, rbSubCache[handle]);
      return;
    }
    if(form.dataset.rbsub==="pending") return;
    form.dataset.rbsub="pending";
    fetch("/products/"+handle+".js",{headers:{"Accept":"application/json"}}).then(function(r){return r.json();}).then(function(pr){
      try{ form.dataset.rbsub=""; }catch(e){}
      var grp=(pr.selling_plan_groups||[])[0];
      var plan=grp&&grp.selling_plans&&grp.selling_plans[0];
      rbSubCache[handle]= plan? plan.id : null;
      if(plan) subEnsure(form, plan.id);
    }).catch(function(){ try{ form.dataset.rbsub=""; }catch(e){} });
  }
  var rbSubObs=false, rbSubT;
  function subWatch(){
    subDefault();
    if(rbSubObs) return; rbSubObs=true;
    try{
      var mo=new MutationObserver(function(){ clearTimeout(rbSubT); rbSubT=setTimeout(subDefault,150); });
      mo.observe(document.body,{childList:true,subtree:true});
    }catch(e){}
  }

  /* ---------- band PDP: full-bleed "look inside" — ONE wide teardown clip scroll-scrubbed; each THERAPY layer isolates (others glide away), text overlaid on the video below the device ---------- */
  var RBL3_CSS = ""
   +".rbl3{position:relative;width:100vw;margin-left:calc(50% - 50vw);height:250vh;background:#0a0707;overflow-x:clip;}"
   +".rbl3 *{box-sizing:border-box;}"
   +".rbl3__pin{position:sticky;top:10vh;height:78vh;overflow:hidden;background:#0a0707;color:#efe7df;}"
   +".rbl3__vid{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;background:#0a0707;}"
   +".rbl3__scrim{position:absolute;inset:0;pointer-events:none;background:linear-gradient(to top,rgba(8,6,6,.92) 3%,rgba(8,6,6,0) 46%),linear-gradient(to bottom,rgba(8,6,6,.7) 0%,rgba(8,6,6,0) 20%),radial-gradient(120% 70% at 50% 40%,rgba(228,18,27,.1),rgba(228,18,27,0) 60%);}"
   +".rbl3__top{position:absolute;left:0;right:0;top:clamp(22px,5vh,58px);text-align:center;padding:0 20px;z-index:3;}"
   +".rbl3__eye{display:inline-flex;align-items:center;gap:11px;font-family:'IBM Plex Mono',monospace;font-size:11px;font-weight:600;letter-spacing:.22em;text-transform:uppercase;color:#ff6b70;margin:0 0 10px;}"
   +".rbl3__eye i{display:inline-block;width:22px;height:2px;background:#E4121B;}"
   +".rbl3__h{font-family:'Fraunces',Georgia,serif;font-weight:400;font-size:clamp(22px,3vw,40px);line-height:1.04;letter-spacing:-.022em;color:#fdf4f0;margin:0;text-shadow:0 2px 30px rgba(0,0,0,.65);}"
   +".rbl3__h em{font-style:italic;color:#ff5a60;}"
   +".rbl3__txt{position:absolute;left:0;right:0;bottom:clamp(96px,17vh,168px);text-align:center;padding:0 clamp(20px,6vw,40px);z-index:3;will-change:opacity,transform;}"
   +".rbl3__num{display:block;font-family:'IBM Plex Mono',monospace;font-size:12px;font-weight:600;letter-spacing:.16em;color:#ff5a60;margin:0 0 10px;}"
   +".rbl3__spec{display:inline-block;margin:0 0 12px;font-family:'IBM Plex Mono',monospace;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#efe7df;border:1.5px solid rgba(255,255,255,.28);border-radius:999px;padding:5px 13px;}"
   +".rbl3__name{font-family:'Fraunces',Georgia,serif;font-weight:400;font-size:clamp(30px,4.6vw,58px);line-height:1.02;letter-spacing:-.02em;color:#fff;margin:0 0 12px;text-shadow:0 2px 34px rgba(0,0,0,.72);}"
   +".rbl3__desc{font-family:'Hanken Grotesk',sans-serif;font-size:clamp(14.5px,1.4vw,18px);line-height:1.55;color:#e9ded6;margin:0 auto;max-width:40ch;text-shadow:0 1px 22px rgba(0,0,0,.85);}"
   +".rbl3__nav{position:absolute;left:0;right:0;bottom:clamp(30px,5vh,56px);display:flex;flex-direction:column;gap:11px;align-items:center;z-index:3;}"
   +".rbl3__dots{display:flex;gap:10px;}"
   +".rbl3__dot{width:26px;height:26px;padding:0;border:0;background:transparent;cursor:pointer;display:flex;align-items:center;justify-content:center;}"
   +".rbl3__dot i{display:block;width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.3);transition:background .3s,transform .3s;}"
   +".rbl3__dot.is-on i{background:#E4121B;transform:scale(1.5);box-shadow:0 0 12px rgba(228,18,27,.85);}"
   +".rbl3__bar{width:min(340px,70vw);height:3px;border-radius:3px;background:rgba(255,255,255,.14);overflow:hidden;}"
   +".rbl3__bar i{display:block;height:100%;width:0;background:linear-gradient(90deg,#E4121B,#ff7a4d);}"
   +"@media(max-width:860px){.rbl3{height:240vh;}.rbl3__pin{top:0;height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:stretch;gap:clamp(14px,2.4vh,26px);padding:7vh 18px;}.rbl3__vid{position:relative;inset:auto;width:100%;height:56.25vw;border-radius:14px;}.rbl3__scrim{display:none;}.rbl3__top{position:static;order:-1;}.rbl3__name{font-size:clamp(25px,7.2vw,33px);margin-bottom:10px;}.rbl3__desc{font-size:15px;}.rbl3__txt{position:static;}.rbl3__nav{position:static;margin-top:clamp(4px,1vh,12px);}}"
   +".nura__tech .nura__ph--wide{display:none !important;}";

  function rbl3HTML(poster, vsrc){
    var dots='';
    for(var d=0;d<5;d++){ dots+='<button class="rbl3__dot'+(d===0?' is-on':'')+'" data-d="'+d+'" aria-label="therapy layer '+(d+1)+'"><i></i></button>'; }
    return ''
     +'<div class="rbl3__pin">'
     +  '<video class="rbl3__vid" poster="'+poster+'" muted playsinline webkit-playsinline preload="auto"'+(vsrc?(' src="'+vsrc+'"'):'')+'></video>'
     +  '<div class="rbl3__scrim"><i></i></div>'
     +  '<div class="rbl3__top"><span class="rbl3__eye"><i></i>Engineered in layers</span><h2 class="rbl3__h">Five therapies, <em>one wrap</em></h2></div>'
     +  '<div class="rbl3__txt">'
     +    '<span class="rbl3__num"><b data-num>01</b> / 05</span>'
     +    '<span class="rbl3__spec" data-spec></span>'
     +    '<h3 class="rbl3__name" data-name></h3>'
     +    '<p class="rbl3__desc" data-desc></p>'
     +  '</div>'
     +  '<div class="rbl3__nav"><div class="rbl3__dots">'+dots+'</div><div class="rbl3__bar"><i data-bar></i></div></div>'
     +'</div>';
  }

  function bandLayers(){
    if(location.pathname.indexOf('/products/')===-1) return;
    var cut=document.querySelector('.nura__tech .nura__ph--wide'); if(!cut) return;   /* band PDPs only */
    if(document.querySelector('.rbl3')) return;
    if(!document.getElementById('rbl3-css')){ var cs=document.createElement('style'); cs.id='rbl3-css'; cs.textContent=RBL3_CSS; document.head.appendChild(cs); }
    var poster=(window.__rblAllImg||'https://cdn.shopify.com/s/files/1/1117/4900/5650/files/hf_20261023_034412_4977fbbb-c917-489b-8f8b-85869c3b247c.png?v=1792728145&width=1200');
    var vsrc=(window.__rblLayersVid||'');
    var wrap=document.createElement('div'); wrap.className='rbl3'; wrap.innerHTML=rbl3HTML(poster,vsrc);
    cut.parentNode.replaceChild(wrap,cut);
    var pin=wrap.querySelector('.rbl3__pin'), vid=wrap.querySelector('.rbl3__vid'), txt=wrap.querySelector('.rbl3__txt');
    var dots=[].slice.call(wrap.querySelectorAll('.rbl3__dot'));
    var numEl=wrap.querySelector('[data-num]'), specEl=wrap.querySelector('[data-spec]'), nameEl=wrap.querySelector('[data-name]'), descEl=wrap.querySelector('[data-desc]'), bar=wrap.querySelector('[data-bar]');
    var specs=['660 nm','808 nm','Micro-current','Bio-ceramic','EMS-synced'];
    var names=['Red-light therapy','Laser (near-infrared)','Galvanic current','Far-infrared heat','Collagen activation'];
    var descs=[
      'Clinic-grade 660nm red light floods the skin to lift circulation and switch collagen back on — for firmer, smoother, more even-looking skin.',
      'Focused near-infrared light drives far deeper than LEDs to reach stubborn tissue and kick-start repair where it counts.',
      'A gentle galvanic micro-current re-educates the muscle wall and firms slack skin from the inside out.',
      'A bio-ceramic far-infrared core warms the deeper layers to relax tissue and supercharge lymphatic drainage.',
      'EMS-synced stimulation triggers a remodeling cascade — denser, bouncier, visibly tightened skin over your cycle.'
    ];
    numEl.textContent='01'; specEl.innerHTML=specs[0]; nameEl.textContent=names[0]; descEl.textContent=descs[0];
    /* SIMPLE + RELIABLE: a tall track with a sticky video that scrubs through the 5 layers as you scroll the PAGE
       normally. No scroll hijacking, no nested scroller, no snap — it just works: responsive, never traps, never sticks. */
    var curK=-1, raf=0, dur=0, expanded=true, lastY=(window.scrollY||0);
    function progress(){
      var r=wrap.getBoundingClientRect();
      var topPx=parseFloat(getComputedStyle(pin).top)||0;
      var travel=wrap.offsetHeight - pin.offsetHeight; if(travel<=0) travel=1;
      var pp=(topPx - r.top)/travel; if(pp<0)pp=0; if(pp>1)pp=1;
      return pp;
    }
    function apply(pp){
      if(dur){ try{ vid.currentTime=pp*(dur*0.9-0.03); }catch(e){} }
      var u=pp*9;
      var k=Math.round((u-1)/2); if(k<0)k=0; if(k>4)k=4;
      var T=Math.abs(u-(2*k+1)); if(T>1)T=1;
      txt.style.opacity=(1-T).toFixed(3);
      txt.style.transform='translateY('+(T*10).toFixed(1)+'px)';
      if(bar) bar.style.width=(pp*100).toFixed(1)+'%';
      if(k!==curK){ curK=k;
        numEl.textContent=('0'+(k+1)).slice(-2);
        specEl.innerHTML=specs[k]; nameEl.textContent=names[k]; descEl.textContent=descs[k];
        for(var j=0;j<dots.length;j++) dots[j].classList.toggle('is-on',j===k);
      }
    }
    function topPxNow(){ return parseFloat(getComputedStyle(pin).top)||0; }
    function layerTop(k){ var travel=wrap.offsetHeight-pin.offsetHeight; if(travel<=0)travel=1; return Math.round(wrap.getBoundingClientRect().top+window.scrollY-topPxNow()+((2*k+1)/9)*travel); }
    function render(){ raf=0; if(!expanded) return; apply(progress()); }
    function setExpanded(exp){
      if(exp===expanded) return;
      var y=window.scrollY, oldH=wrap.offsetHeight;
      wrap.style.height = exp ? '' : (pin.offsetHeight+'px');
      var newH=wrap.offsetHeight;
      expanded=exp;
      if(!exp){ var ny=y+(newH-oldH); if(ny<0)ny=0; try{ window.scrollTo(0,ny); }catch(e){} }  /* compensate only when collapsing (section above viewport) */
      lastY=window.scrollY;
    }
    function onScroll(){
      var y=window.scrollY, dir=y-lastY;
      var r=wrap.getBoundingClientRect(), vh=window.innerHeight||1;
      var topDoc=r.top+y, botDoc=topDoc+wrap.offsetHeight;
      if(dir<0 && expanded && y>botDoc){ setExpanded(false); }            /* scrolled up past it → collapse so it just passes */
      else if(dir>0 && !expanded && (y+vh)<topDoc){ setExpanded(true); }  /* scrolling back down toward it → re-expand */
      lastY=window.scrollY;
      if(!raf) raf=requestAnimationFrame(render);
    }
    function ready(){
      dur=vid.duration||0;
      try{ var pr=vid.play(); if(pr&&pr.then){ pr.then(function(){ try{vid.pause();}catch(e){} render(); }).catch(function(){ render(); }); } else { try{vid.pause();}catch(e){} render(); } }catch(e){ render(); }
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',onScroll,{passive:true});
      render();
    }
    if(vid.readyState>=1 && vid.duration) ready(); else vid.addEventListener('loadedmetadata',ready);
    setTimeout(function(){ if(!dur){ window.addEventListener('scroll',onScroll,{passive:true}); render(); } }, 1500);
    dots.forEach(function(dot){ dot.addEventListener('click',function(){
      if(!expanded){ wrap.style.height=''; expanded=true; }
      window.scrollTo({top:layerTop(parseInt(dot.getAttribute('data-d'),10)),behavior:'smooth'});
    }); });
  }

  /* ---------- thigh PDP only: add a "Stubborn fat" before/after case to the "Proof, problem by problem" gallery ---------- */
  function thighFat(){
    if(location.pathname.indexOf('/products/')===-1) return;
    if(location.pathname.indexOf('thigh')===-1) return;        /* thigh PDP only */
    /* (1) add a "Stubborn fat" before/after case to the "Proof, problem by problem" gallery */
    var cases=document.querySelector('.nura__cases');
    if(cases && !cases.querySelector('[data-tf="1"]')){
      var bImg=window.__thighBefore||'', aImg=window.__thighAfter||'';
      if(bImg && aImg){
        var st='position:absolute;inset:0;width:100%;height:100%;object-fit:cover;border-radius:var(--rad-chip);';
        var card=document.createElement('div'); card.className='nura__case'; card.setAttribute('data-tf','1');
        card.innerHTML=''
         +'<span class="nura__case-tag">Stubborn fat</span>'
         +'<div class="nura__case-ba">'
         +  '<div class="nura__case-ph"><img src="'+bImg+'" alt="Stubborn fat before" loading="lazy" style="'+st+'"><span class="nura__case-lab">Before</span></div>'
         +  '<div class="nura__case-ph nura__case-ph--a"><img src="'+aImg+'" alt="Stubborn fat after" loading="lazy" style="'+st+'"><span class="nura__case-lab">After</span></div>'
         +'</div>';
        cases.insertBefore(card, cases.firstChild);            /* show it first */
      }
    }
    /* (2) add "Stubborn fat" as a selectable concern in the "What are you working on?" selector */
    var cs=document.querySelector('.nura__cs');
    if(cs){
      var chips=cs.querySelector('.nura__cs-chips'), panels=cs.querySelector('.nura__cs-panels');
      if(chips && panels && !cs.querySelector('[data-cs="4"]')){
        var chip=document.createElement('button'); chip.type='button'; chip.className='nura__cs-chip'; chip.setAttribute('data-cs','4'); chip.textContent='Stubborn fat';
        chips.appendChild(chip);
        var panel=document.createElement('div'); panel.className='nura__cs-panel'; panel.setAttribute('data-cspanel','4');
        panel.innerHTML=''
         +'<h3 class="nura__cs-h">Melt away stubborn fat</h3>'
         +'<p class="nura__cs-p">660nm red and 850nm near-infrared light are thought to help fat cells release what they store while lifting circulation and lymphatic drainage — so stubborn, diet-resistant thigh fat gradually looks softer, slimmer and more toned.</p>'
         +'<p class="nura__cs-stat"><span class="nura__cs-dot"></span>A slimmer-looking thigh contour over 8–12 weeks</p>';
        panels.appendChild(panel);
      }
      if(chips && !chips.dataset.tfbound){ chips.dataset.tfbound='1';
        chips.addEventListener('click', function(e){
          var b=e.target.closest ? e.target.closest('.nura__cs-chip') : null;
          if(!b || !chips.contains(b)) return;
          var idx=b.getAttribute('data-cs');
          [].forEach.call(cs.querySelectorAll('.nura__cs-chip'), function(c){ c.classList.toggle('is-active', c===b); });
          [].forEach.call(cs.querySelectorAll('.nura__cs-panel'), function(pl){ pl.classList.toggle('is-active', pl.getAttribute('data-cspanel')===idx); });
        });
      }
    }
  }

  /* ---------- sitewide: refresh the give-back ("Compassion Beyond Beauty") copy + drop the beige bg ---------- */
  function fixGive(){
    var NEW_BODY='Beauty should make a difference. That’s why 0.5% of every RubyBeam purchase supports The Humane League and its mission to end the abuse of animals raised for food.';
    var all=document.querySelectorAll('div,span,h2,h3,p,b,strong');
    for(var i=0;i<all.length;i++){
      var t=all[i];
      if(t.dataset.rbg || t.children.length!==0) continue;
      if(!/compassion beyond beauty/i.test(t.textContent)) continue;
      t.dataset.rbg='1';
      t.textContent='Compassion Beyond Beauty';
      var body=t.nextElementSibling;
      if(!body || body.children.length!==0 || !/0\.5%|humane|donated/i.test(body.textContent)){
        var p=t.parentElement, cand=[];
        if(p) cand=[].slice.call(p.querySelectorAll('div,p,span')).filter(function(e){return e!==t && e.children.length===0 && /0\.5%|humane|donated/i.test(e.textContent);});
        if(cand.length) body=cand[0];
      }
      if(body) body.textContent=NEW_BODY;
      var w=t;
      for(var j=0;j<8&&w;j++){ try{ if(getComputedStyle(w).backgroundColor==='rgb(245, 240, 232)'){ w.style.background='#fff'; break; } }catch(e){} w=w.parentElement; }
    }
  }

  /* reveal the percentage gauges ONE AFTER ANOTHER (staggered), not all at the same time */
  function staggerGauges(){
    document.querySelectorAll(".nura__gauges").forEach(function(grp){
      var gs=grp.querySelectorAll(".nura__gauge");
      for(var i=0;i<gs.length;i++){
        gs[i].style.transitionDelay=(i*0.35).toFixed(2)+"s";
        gs[i].querySelectorAll("circle").forEach(function(c){ c.style.transitionDelay=(i*0.35+0.15).toFixed(2)+"s"; });
      }
    });
  }
  function init(){ try{ homeFont(); }catch(e){} try{ staggerGauges(); }catch(e){} try{ homeHero(); }catch(e){} try{ buildGraph(); }catch(e){} try{ watchNbvc(); }catch(e){} try{ fixCopy(); }catch(e){} try{ revealNav(); }catch(e){} try{ storyEdits(); }catch(e){} try{ tailorPortable(); }catch(e){} try{ tailorLymph(); }catch(e){} try{ rbDotsWatch(); }catch(e){} try{ cartUpsell(); }catch(e){} try{ subWatch(); }catch(e){} try{ bandLayers(); }catch(e){} try{ thighFat(); }catch(e){} try{ fixGive(); }catch(e){} }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function(){ clampScroll(); init(); });
  else { clampScroll(); init(); }
  var tries=0; var iv=setInterval(function(){ init(); if(++tries>20) clearInterval(iv); }, 500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-story"] && !Shopify.designMode) return;
  try {
    
/* ============================================================================
   RUBYBEAM STORY — consolidated JS (goes inside the javascript block).
   (a) scroll-reveal observer (adds .is-anim to root, .is-in to children)
   (b) data-viz: chart draw-in + gauge sweep + count-ups via IntersectionObserver
   (c) DOMContentLoaded setup: gauge bezel ticks + SVG path-length measuring
   (d) offer countdown timer (preserved verbatim)
   Plain JS. No Liquid. Guarded with prefers-reduced-motion + IO feature-detect.
   ============================================================================ */

/* ---- (a) SCROLL REVEAL ------------------------------------------------------ */
(function(){
  var root = document.querySelector(".nura");
  if(!root) return;
  var reduce = false;
  try{ reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches; }catch(e){}
  /* No IO or reduced motion: leave every child in its default (fully visible) state. */
  if(reduce || !("IntersectionObserver" in window)) return;

  root.classList.add("is-anim");
  var kids = Array.prototype.slice.call(root.children);
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add("is-in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  kids.forEach(function(k){ io.observe(k); });

  /* Safety net: if the observer never fires for a node, reveal everything. */
  setTimeout(function(){
    kids.forEach(function(k){ k.classList.add("is-in"); });
  }, 4000);
})();

/* ---- (b)+(c) DATA-VIZ: oscilloscope chart + precision gauge cluster --------- */
(function(){
  if(window.__nuraVizInit) return; window.__nuraVizInit = true;
  var reduce = false;
  try{ reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches; }catch(e){}

  function fmt(v, dec){ return dec ? v.toFixed(1) : String(Math.round(v)); }

  function countUp(el){
    if(!el) return;
    var dec = el.hasAttribute("data-end");
    var start = dec ? parseFloat(el.getAttribute("data-start") || "0") : 0;
    var end = dec ? parseFloat(el.getAttribute("data-end")) : parseFloat(el.getAttribute("data-count"));
    if(isNaN(end)) return;
    if(reduce){ el.textContent = fmt(end, dec); return; }
    var dur = 1500, t0 = null;
    function step(ts){
      if(t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(start + (end - start) * e, dec);
      if(p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* gauge: arc dash math, needle-tip probe, 60 bezel ticks (generated once) */
  function setupGauge(g, idx){
    var arc = g.querySelector(".nura__gauge-arc"),
        probe = g.querySelector(".nura__gauge-probe"),
        ticks = g.querySelector(".nura__gauge-ticks"),
        val = parseFloat(g.getAttribute("data-val")) || 0;
    if(arc && arc.getTotalLength){
      var len = arc.getTotalLength(),
          target = len * (1 - val / 100),
          under = len * (1 - Math.min(val + 2.5, 100) / 100);
      arc.style.setProperty("--sweep", len.toFixed(2));
      arc.style.setProperty("--arc-target", target.toFixed(2));
      arc.style.setProperty("--arc-under", under.toFixed(2));
      arc.style.strokeDasharray = len.toFixed(2);
      arc.style.strokeDashoffset = len.toFixed(2);
      arc.style.animationDelay = (idx * 0.12) + "s";
      if(probe && arc.getPointAtLength){
        var pt = arc.getPointAtLength(len * val / 100);
        probe.setAttribute("cx", pt.x.toFixed(2));
        probe.setAttribute("cy", pt.y.toFixed(2));
        probe.style.transitionDelay = (0.55 + idx * 0.12) + "s";
      }
    }
    if(ticks && !ticks.childNodes.length){
      var N = 60, SVGNS = "http://www.w3.org/2000/svg", frag = document.createDocumentFragment();
      for(var i = 0; i <= N; i++){
        var ang = (135 + (i / N) * 270) * Math.PI / 180,
            cos = Math.cos(ang), sin = Math.sin(ang),
            maj = (i % 15 === 0), ri = maj ? 75 : 80, ro = 86,
            ln = document.createElementNS(SVGNS, "line");
        ln.setAttribute("x1", (100 + ri * cos).toFixed(2));
        ln.setAttribute("y1", (100 + ri * sin).toFixed(2));
        ln.setAttribute("x2", (100 + ro * cos).toFixed(2));
        ln.setAttribute("y2", (100 + ro * sin).toFixed(2));
        var cls = "nura__gtick";
        if((i / N) <= (val / 100)) cls += " is-cov";
        if(maj) cls += " is-maj";
        ln.setAttribute("class", cls);
        frag.appendChild(ln);
      }
      ticks.appendChild(frag);
    }
  }

  /* scope: measure path length so the CSS draw-on knows how far to travel */
  function setupScope(fig){
    var lines = fig.querySelectorAll(".nura__scope-line");
    for(var i = 0; i < lines.length; i++){
      if(lines[i].getTotalLength) lines[i].style.setProperty("--len", lines[i].getTotalLength().toFixed(1));
    }
  }

  /* scope: count the readout + ride the probe along the measured trace */
  function runScope(fig){
    countUp(fig.querySelector(".nura__svis-val"));
    var main = fig.querySelector(".nura__scope-line--main");
    if(!main || !main.getTotalLength || !main.getPointAtLength) return;
    var cur = fig.querySelector(".nura__scope-cursorline"),
        p = fig.querySelector(".nura__scope-probe"),
        c = fig.querySelector(".nura__scope-probe-core"),
        len = main.getTotalLength();
    function place(f){
      var pt = main.getPointAtLength(len * f);
      if(cur){ cur.setAttribute("x1", pt.x.toFixed(2)); cur.setAttribute("x2", pt.x.toFixed(2)); }
      if(p){ p.setAttribute("cx", pt.x.toFixed(2)); p.setAttribute("cy", pt.y.toFixed(2)); }
      if(c){ c.setAttribute("cx", pt.x.toFixed(2)); c.setAttribute("cy", pt.y.toFixed(2)); }
    }
    if(reduce){ place(1); if(cur) cur.style.display = "none"; return; }
    place(0);
    var dur = 1400, t0 = null;
    function step(ts){
      if(t0 === null) t0 = ts;
      var pr = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - pr, 2.2);
      place(e);
      if(pr < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init(){
    var scopes = Array.prototype.slice.call(document.querySelectorAll(".nura__scope")),
        gauges = Array.prototype.slice.call(document.querySelectorAll(".nura__gauge"));
    scopes.forEach(setupScope);
    gauges.forEach(function(g, i){ setupGauge(g, i); });

    if(reduce || !("IntersectionObserver" in window)){
      scopes.forEach(function(s){ s.classList.add("is-in"); runScope(s); });
      gauges.forEach(function(g){ g.classList.add("is-in"); countUp(g.querySelector(".nura__val")); });
      return;
    }

    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(en){
        if(!en.isIntersecting) return;
        var el = en.target; el.classList.add("is-in");
        if(el.classList.contains("nura__scope")) runScope(el);
        else if(el.classList.contains("nura__gauge")) countUp(el.querySelector(".nura__val"));
        io.unobserve(el);
      });
    }, { threshold: 0.35, rootMargin: "0px 0px -8% 0px" });
    scopes.forEach(function(s){ io.observe(s); });
    gauges.forEach(function(g){ io.observe(g); });

    /* Safety net: reveal/draw any viz still untouched after 3s (broken observer). */
    setTimeout(function(){
      scopes.forEach(function(s){ if(!s.classList.contains("is-in")){ s.classList.add("is-in"); runScope(s); } });
      gauges.forEach(function(g){ if(!g.classList.contains("is-in")){ g.classList.add("is-in"); countUp(g.querySelector(".nura__val")); } });
    }, 3000);
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* ---- (d) OFFER COUNTDOWN TIMER (preserved verbatim) ------------------------- */
(function(){
  var el = document.querySelector("[data-countdown]");
  if(!el) return;
  var h = el.querySelector("[data-h]"), m = el.querySelector("[data-m]"), s = el.querySelector("[data-s]");
  function pad(n){ return n < 10 ? "0" + n : "" + n; }
  function tick(){
    var KEY="nura_deadline_v2", SPAN=86400000, now=Date.now();
    var d=0; try{ d=parseInt(localStorage.getItem(KEY)||"0",10); }catch(e){}
    if(!d || d<=now){ d=now+SPAN; try{localStorage.setItem(KEY,d);}catch(e){} }
    var diff = Math.max(0, Math.floor((d - now) / 1000));
    if(h) h.textContent = pad(Math.floor(diff / 3600));
    if(m) m.textContent = pad(Math.floor((diff % 3600) / 60));
    if(s) s.textContent = pad(diff % 60);
  }
  tick(); setInterval(tick, 1000);
})();

document.querySelectorAll(".nura__cs").forEach(function(cs){
  var chips = cs.querySelectorAll("[data-cs]");
  var panels = cs.querySelectorAll("[data-cspanel]");
  chips.forEach(function(ch){
    ch.addEventListener("click", function(){
      var k = ch.getAttribute("data-cs");
      chips.forEach(function(c){ c.classList.toggle("is-active", c === ch); });
      panels.forEach(function(p){ p.classList.toggle("is-active", p.getAttribute("data-cspanel") === k); });
      var cases = document.querySelector(".nura__cases");
      if(cases){
        var items = cases.querySelectorAll(".nura__case");
        /* match the selected concern to the closest before/after by shared keywords
           (the chip list and the proof carousel are curated separately, so index != index) */
        var STOP={and:1,the:1,of:1,to:1,in:1,your:1,with:1,water:1,weight:1,after:1,that:1,wont:1,move:1};
        function toks(s){return (s||"").toLowerCase().replace(/[^a-z\s-]/g," ").split(/[\s-]+/).filter(function(w){return w.length>2 && !STOP[w];});}
        var want=toks(ch.textContent), matchIdx=-1, bestScore=0;
        items.forEach(function(it,i){
          var tag=it.querySelector(".nura__case-tag"); if(!tag) return;
          var have=toks(tag.textContent), score=0;
          want.forEach(function(w){ if(have.indexOf(w)>=0) score++; });
          if(score>bestScore){ bestScore=score; matchIdx=i; }
        });
        var targetEl = (matchIdx>=0 ? items[matchIdx] : cases);
        var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        var startY = window.pageYOffset;
        var destY = Math.max(0, cases.getBoundingClientRect().top + startY - 110);
        function align(){
          if(matchIdx<0) return;
          var cr=cases.getBoundingClientRect(), ir=targetEl.getBoundingClientRect();
          cases.scrollLeft += (ir.left - cr.left) - 14;
          targetEl.classList.add("is-cshi");
          setTimeout(function(){ targetEl.classList.remove("is-cshi"); }, 1700);
        }
        if(reduce){ window.scrollTo(0, destY); align(); }
        else {
          /* manual rAF scroll — robust even where native smooth scroll is disabled */
          var t0=null, dur=520;
          (function step(ts){
            if(t0===null) t0=ts;
            var p=Math.min(1,(ts-t0)/dur), e=p<0.5?2*p*p:1-Math.pow(-2*p+2,2)/2;
            window.scrollTo(0, startY+(destY-startY)*e);
            if(p<1) requestAnimationFrame(step); else align();
          })(performance.now());
        }
      }
    });
  });
});

/* ---- (d1) SURVEY STAT CARDS — count each number up from 0 as the grid scrolls into view */
(function(){
  var grid = document.querySelector(".nsurvey"); if(!grid) return;
  var nums = [].slice.call(grid.querySelectorAll(".nsc-num")); if(!nums.length) return;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var rafs = [], animating = false;
  function stop(){ rafs.forEach(function(r){ cancelAnimationFrame(r); }); rafs = []; }
  function setZero(){ stop(); animating = false; nums.forEach(function(el){ el.textContent = "0"; }); }
  function run(){
    if(animating) return; animating = true;
    stop();
    nums.forEach(function(el){
      var to = parseInt(el.getAttribute("data-stat"), 10) || 0;
      if(reduce){ el.textContent = to; return; }
      var dur = 1400, t0 = null;
      function step(ts){
        if(t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e);
        if(p < 1) rafs.push(requestAnimationFrame(step)); else { el.textContent = to; animating = false; }
      }
      rafs.push(requestAnimationFrame(step));
    });
  }
  if(reduce || !("IntersectionObserver" in window)){ run(); return; }
  /* re-count every time the grid scrolls back into view; reset to 0 when it leaves */
  var io = new IntersectionObserver(function(ents){
    ents.forEach(function(en){ if(en.isIntersecting){ run(); } else { setZero(); } });
  }, { threshold: 0.35, rootMargin: "0px 0px -8% 0px" });
  io.observe(grid);
})();

/* ---- (d2) 30-DAY TIMELINE — rail fills and dots light up as you scroll through it */
(function(){
  var ph = document.querySelector(".nphase"); if(!ph) return;
  var prog = document.createElement("div"); prog.className = "nphase__prog";
  var fill = document.createElement("span"); fill.className = "nphase__prog-fill";
  prog.appendChild(fill); ph.insertBefore(prog, ph.firstChild);
  var dots = [].slice.call(ph.querySelectorAll(".nphase__dot"));
  var topOff = 0, railLen = 0;
  function layout(){
    if(!dots.length) return;
    var pr = ph.getBoundingClientRect();
    var f = dots[0].getBoundingClientRect(), l = dots[dots.length-1].getBoundingClientRect();
    topOff = (f.top - pr.top) + f.height/2;
    railLen = ((l.top - pr.top) + l.height/2) - topOff;
    prog.style.top = topOff + "px"; prog.style.height = railLen + "px";
  }
  function update(){
    if(!dots.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var readY = vh * 0.62;                          // fixed read line: dots light as they scroll above it
    var pr = ph.getBoundingClientRect();
    var firstY = pr.top + topOff;                   // first dot, viewport coords
    var h = Math.max(0, Math.min(railLen, readY - firstY));
    fill.style.height = h + "px";
    dots.forEach(function(d){
      var r = d.getBoundingClientRect(), c = r.top + r.height/2;
      var on = c <= readY + 2;
      d.classList.toggle("is-on", on);
      var row = d.closest(".nphase__row"); if(row){ row.classList.toggle("is-reached", on); }
    });
  }
  var ticking = false;
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(function(){ layout(); update(); ticking = false; }); } }
  window.addEventListener("scroll", onScroll, {passive:true});
  window.addEventListener("resize", function(){ layout(); update(); });
  layout(); update();
  setTimeout(function(){ layout(); update(); }, 400);
})();

/* ---- (e) STICKY ADD-TO-CART — real ATC, revealed only after main ATC scrolls past */
(function(){
  var bar = document.querySelector("[data-sticky-atc]");
  if(!bar) return;
  var mainBtn = document.querySelector('.product-form__submit, product-form button[type="submit"], form[action*="/cart/add"] [type="submit"]');
  var addBtn = bar.querySelector("[data-sticky-add]");
  if(addBtn){
    addBtn.addEventListener("click", function(){
      if(mainBtn && !mainBtn.disabled){ mainBtn.click(); return; }
      var f = document.querySelector('form[action*="/cart/add"]');
      if(f){ if(f.requestSubmit){ f.requestSubmit(); } else { f.submit(); } }
    });
  }
  function reveal(on){ bar.classList.toggle("is-visible", on); bar.setAttribute("aria-hidden", on ? "false" : "true"); }
  if(mainBtn && "IntersectionObserver" in window){
    var io = new IntersectionObserver(function(entries){
      var e = entries[0];
      /* show only once the main Add-to-cart has scrolled up and out of view */
      reveal(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, {threshold:0});
    io.observe(mainBtn);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
